import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { Handle, Position } from 'reactflow'
import { AppTheme } from '../../../../styles/AppTheme'
import { ChatbotNodeHeader, chatbotNodeIcon } from './ChatbotNodeHeader'
import { ChatbotTargetHandle } from './ChatbotTargetHandle'
import { AGENT_HANDLES, NODE_TYPE_AGENT } from './chatbotGraph'

const HANDLE_STYLE = {
  width: 10,
  height: 10,
  background: AppTheme.primaryColor,
  border: '2px solid #ffffff',
}

function truncate(text, max) {
  const s = String(text || '').trim()
  if (!s) return ''
  if (s.length <= max) return s
  return s.slice(0, max) + '…'
}

export function ChatbotAgentNode(props) {
  const data = props.data || {}
  const providerLabel = String(data.providerLabel || data.providerId || '').trim()
  const openingMessage = String(data.openingMessage || '').trim()
  return (
    <div className={css(Styles.card, props.selected && Styles.cardSelected)}>
      <ChatbotTargetHandle hidden={!!data.isStartNode} style={HANDLE_STYLE} />
      <ChatbotNodeHeader
        title='Trigger Agent'
        icon={chatbotNodeIcon(NODE_TYPE_AGENT)}
        tone='crm'
        isStartNode={data.isStartNode}
        onDelete={data.onDelete}
        onDuplicate={data.onDuplicate}
        onSetStartNode={data.onSetStartNode}
      />
      <div className={css(Styles.body)}>
        {providerLabel ? (
          <div className={css(Styles.rows)}>
            <div>
              <div className={css(Styles.rowLabel)}>AI Agent</div>
              <div className={css(Styles.value)}>{providerLabel}</div>
            </div>
            {openingMessage ? (
              <div>
                <div className={css(Styles.rowLabel)}>Opening message</div>
                <div className={css(Styles.value)}>{truncate(openingMessage, 80)}</div>
              </div>
            ) : null}
          </div>
        ) : (
          <div className={css(Styles.empty)}>No AI agent selected</div>
        )}
      </div>
      <div className={css(Styles.outcomes)}>
        {AGENT_HANDLES.map(h => (
          <div key={h.id} className={css(Styles.outcomeRow)}>
            <i className={'material-icons-outlined ' + css(Styles.outcomeIcon)}>{h.icon}</i>
            <div className={css(Styles.outcomeLabel)}>{h.label}</div>
            <Handle
              type='source'
              position={Position.Right}
              id={h.id}
              style={HANDLE_STYLE}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  card: {
    width: 240,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    overflow: 'visible',
    boxSizing: 'border-box',
  },
  cardSelected: {
    borderColor: AppTheme.primaryColor,
    boxShadow: '0 0 0 3px ' + AppTheme.primaryColor + '33',
  },
  body: {
    padding: '10px 12px 12px',
    textAlign: 'left',
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  rowLabel: {
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 600,
    color: '#6B7280',
    marginBottom: 4,
  },
  value: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#222222',
    wordBreak: 'break-word',
  },
  empty: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#6B7280',
  },
  outcomes: {
    overflow: 'visible',
  },
  outcomeRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '8px 16px 8px 12px',
    borderTop: '1px solid ' + AppTheme.borderColor,
    boxSizing: 'border-box',
    overflow: 'visible',
    color: '#6B7280',
  },
  outcomeIcon: {
    fontSize: 16,
    lineHeight: 1,
    color: '#6B7280',
  },
  outcomeLabel: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 600,
    color: '#374151',
  },
})
